import { CommonModule } from '@angular/common';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { Component, Input, NgModule } from '@angular/core';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @enum {string} */
import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/common';
import * as ɵngcc2 from 'ng2-pdf-viewer';

function FileViewerComponent_span_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span");
    ɵngcc0.ɵɵelement(1, "pdf-viewer", 3);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("src", ctx_r0.src)("show-all", true)("zoom", ctx_r0.pdfZoom);
} }
function FileViewerComponent_span_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span");
    ɵngcc0.ɵɵelement(1, "img", 4);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("src", ctx_r1.src, ɵngcc0.ɵɵsanitizeUrl);
} }
function FileViewerComponent_span_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span");
    ɵngcc0.ɵɵelement(1, "img", 4);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("src", ctx_r2.src, ɵngcc0.ɵɵsanitizeUrl);
} }
function FileViewerComponent_span_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span")(1, "video", 5);
    ɵngcc0.ɵɵelement(2, "source", 6);
    ɵngcc0.ɵɵtext(3, " Your browser does not support HTML5 video. ");
    ɵngcc0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r3 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("src", ctx_r3.src, ɵngcc0.ɵɵsanitizeUrl);
} }
function FileViewerComponent_span_5_span_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span");
    ɵngcc0.ɵɵtext(1, "File type is not supported");
    ɵngcc0.ɵɵelementEnd();
} }
function FileViewerComponent_span_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span")(1, "span", null, 7);
    ɵngcc0.ɵɵprojection(3);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(4, FileViewerComponent_span_5_span_4_Template, 2, 0, "span", 8);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const _r5 = ɵngcc0.ɵɵreference(2);
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵproperty("ngIf", !_r5.innerHTML.trim());
} }
const _c0 = ["*"];
const FileMimeType = {
    PDF: 'application/pdf',
    JPEG: 'image/jpeg',
    PNG: 'image/png',
    MP4: 'video/mp4',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class FileViewerComponent {
    constructor() {
        this.fileMimeType = FileMimeType;
        this.pdfZoom = 1;
    }
}
FileViewerComponent.ɵfac = function FileViewerComponent_Factory(t) { return new (t || FileViewerComponent)(); };
FileViewerComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: FileViewerComponent, selectors: [["tld-file-viewer"]], inputs: { pdfZoom: "pdfZoom", type: "type", src: "src" }, ngContentSelectors: _c0, decls: 6, vars: 5, consts: [[3, "ngSwitch"], [4, "ngSwitchCase"], [4, "ngSwitchDefault"], [3, "src", "show-all", "zoom"], [1, "img-responsive", "margin-auto", 3, "src"], ["controls", "", "width", "100%"], ["type", "video/mp4", 3, "src"], ["content", ""], [4, "ngIf"]], template: function FileViewerComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵelementStart(0, "span", 0);
        ɵngcc0.ɵɵtemplate(1, FileViewerComponent_span_1_Template, 2, 3, "span", 1);
        ɵngcc0.ɵɵtemplate(2, FileViewerComponent_span_2_Template, 2, 1, "span", 1);
        ɵngcc0.ɵɵtemplate(3, FileViewerComponent_span_3_Template, 2, 1, "span", 1);
        ɵngcc0.ɵɵtemplate(4, FileViewerComponent_span_4_Template, 4, 1, "span", 1);
        ɵngcc0.ɵɵtemplate(5, FileViewerComponent_span_5_Template, 5, 1, "span", 2);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngSwitch", ctx.type);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngSwitchCase", ctx.fileMimeType.PDF);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngSwitchCase", ctx.fileMimeType.JPEG);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngSwitchCase", ctx.fileMimeType.PNG);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngSwitchCase", ctx.fileMimeType.MP4);
    } }, directives: [ɵngcc1.NgSwitch, ɵngcc1.NgSwitchCase, ɵngcc2.PdfViewerComponent, ɵngcc1.NgSwitchDefault, ɵngcc1.NgIf], styles: [""] });
FileViewerComponent.propDecorators = {
    type: [{ type: Input }],
    src: [{ type: Input }],
    pdfZoom: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(FileViewerComponent, [{
        type: Component,
        args: [{
                selector: 'tld-file-viewer',
                template: "<span [ngSwitch]=\"type\">\r\n  <span *ngSwitchCase=\"fileMimeType.PDF\">\r\n    <pdf-viewer [src]=\"src\" [show-all]=\"true\" [zoom]=\"pdfZoom\"></pdf-viewer>\r\n  </span>\r\n  <span *ngSwitchCase=\"fileMimeType.JPEG\">\r\n    <img [src]=\"src\" class=\"img-responsive margin-auto\">\r\n  </span>\r\n  <span *ngSwitchCase=\"fileMimeType.PNG\">\r\n    <img [src]=\"src\" class=\"img-responsive margin-auto\">\r\n  </span>\r\n  <span *ngSwitchCase=\"fileMimeType.MP4\">\r\n    <video controls width=\"100%\">\r\n      <source [src]=\"src\" type=\"video/mp4\">\r\n      Your browser does not support HTML5 video.\r\n    </video>\r\n  </span>\r\n  <span *ngSwitchDefault>\r\n    <span #content><ng-content></ng-content></span>\r\n    <span *ngIf=\"!content.innerHTML.trim()\">File type is not supported</span>\r\n  </span>\r\n</span>",
                styles: [""]
            }]
    }], function () { return []; }, { pdfZoom: [{
            type: Input
        }], type: [{
            type: Input
        }], src: [{
            type: Input
        }] }); })();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class AngularFileViewerModule {
}
AngularFileViewerModule.ɵfac = function AngularFileViewerModule_Factory(t) { return new (t || AngularFileViewerModule)(); };
AngularFileViewerModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: AngularFileViewerModule });
AngularFileViewerModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[
            CommonModule,
            PdfViewerModule
        ]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(AngularFileViewerModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    PdfViewerModule
                ],
                exports: [
                    FileViewerComponent
                ],
                declarations: [
                    FileViewerComponent
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(AngularFileViewerModule, { declarations: function () { return [FileViewerComponent]; }, imports: function () { return [CommonModule,
        PdfViewerModule]; }, exports: function () { return [FileViewerComponent]; } }); })();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

export { AngularFileViewerModule, FileViewerComponent, FileMimeType };

